import { commonStore } from 'stores';
import { isUserAdmin } from 'utils';

export const useUserRole = () => {
  const user = commonStore((state) => state.user);

  const isAdmin = isUserAdmin(user?.role);

  return { isAdmin };
};
